import React, { useState, useContext } from 'react';
import { Modal, Button, Form, InputGroup, Col, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { NotificationContext } from '../../contexts/notification-context';
import ButtonSubmit from '../../components/button/index';
import { FaEnvelope } from 'react-icons/fa';
import authService from '../../api/authService';
import './index.css';

const EsqueciSenha = () => {
  const navigate = useNavigate();
  const { addNotification } = useContext(NotificationContext);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '' });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      await authService.esqueciSenha(formData.email);
      addNotification('success', 'Solicitação enviada! Verifique seu e-mail para redefinir a senha.');
      navigate('/login');
    } catch (error) {
      setErrors({ email: 'Erro ao solicitar redefinição. Verifique o e-mail e tente novamente.' });
      addNotification('danger', 'Erro ao solicitar redefinição de senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <Modal show={true} centered onHide={() => navigate('/login')}>
        <Modal.Header closeButton>
          <Modal.Title>Esqueci Minha Senha</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={12}>
                <InputGroup>
                  <InputGroup.Text>
                    <FaEnvelope />
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Digite seu e-mail"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </InputGroup>
              </Col>
            </Row>
            <div className="text-end">          
              <ButtonSubmit type="submit" disabled={loading}>
                {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Enviar'}
              </ButtonSubmit>    
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EsqueciSenha;
